import { render, staticRenderFns } from "./Bahn1VideoTeaser.vue?vue&type=template&id=b151f7a0&scoped=true&"
import script from "./Bahn1VideoTeaser.vue?vue&type=script&lang=js&"
export * from "./Bahn1VideoTeaser.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1VideoTeaser.vue?vue&type=style&index=0&id=b151f7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b151f7a0",
  null
  
)

export default component.exports